<template>
  <div v-if="semana" class="card shadow-sm h-100">
    <div
      class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2"
      :class="variant === 'actual' ? 'bg-primary text-white' : 'bg-light'"
    >
      <div class="d-flex align-items-center gap-2">
        <span class="badge" :class="variant === 'actual' ? 'bg-white text-primary' : 'bg-secondary'">
          {{ etiqueta }}
        </span>
        <span class="fw-bold">{{ nombre }}</span>
        <span v-if="tieneOverride" class="badge bg-warning text-dark">
          <i class="bi bi-pencil-fill me-1"></i>Modificado
        </span>
      </div>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <small v-if="rango" :class="variant === 'actual' ? 'text-white-50' : 'text-muted'">
          <i class="bi bi-calendar me-1"></i>{{ rango }}
        </small>
        <a
          v-if="semana.pdfUrl"
          :href="semana.pdfUrl"
          target="_blank"
          class="btn btn-sm"
          :class="variant === 'actual' ? 'btn-light' : 'btn-outline-primary'"
        >
          <i class="bi bi-file-earmark-pdf me-1"></i>Plan
        </a>
        <a
          v-if="semana.recetarioUrl"
          :href="semana.recetarioUrl"
          target="_blank"
          class="btn btn-sm"
          :class="variant === 'actual' ? 'btn-outline-light' : 'btn-outline-secondary'"
        >
          <i class="bi bi-book me-1"></i>Recetario
        </a>
        <button
          v-if="isAdmin && variant === 'actual'"
          class="btn btn-sm"
          :class="variant === 'actual' ? 'btn-outline-light' : 'btn-outline-secondary'"
          @click="$emit('cambiar')"
        >
          <i class="bi bi-shuffle me-1"></i>Cambiar plan
        </button>
        <button
          v-if="isAdmin && tieneOverride && variant === 'actual'"
          class="btn btn-outline-light btn-sm"
          @click="$emit('restaurar')"
        >
          <i class="bi bi-arrow-counterclockwise me-1"></i>Restaurar
        </button>
      </div>
    </div>
    <div class="card-body">
      <NutricionMenuBloques :semana="semana" />
    </div>
  </div>
  <div v-else class="alert alert-info mb-0">
    <i class="bi bi-info-circle me-2"></i>No hay plan configurado para {{ etiqueta.toLowerCase() }}.
  </div>
</template>

<script>
import NutricionMenuBloques from './NutricionMenuBloques.vue';

export default {
  name: 'NutricionPlanCard',
  components: { NutricionMenuBloques },
  props: {
    semana: { type: Object, default: null },
    variant: { type: String, default: 'actual' },
    etiqueta: { type: String, required: true },
    rango: { type: String, default: '' },
    tieneOverride: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
  },
  emits: ['cambiar', 'restaurar'],
  computed: {
    nombre() {
      return (this.semana?.nombre || '').replace(' - Plantilla', '');
    },
  },
};
</script>
